// Kept apart from the editor so the detail, the PDF and the registries don't load TipTap.

const HTML_TAG = /<[a-z][\s\S]*>/i;

const escapeHtml = (text: string) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/**
 * La observación general antes era texto plano. Para los informes viejos, se pasa a párrafos HTML
 * así el editor, el detalle y el PDF respetan los saltos de línea; si ya es HTML se deja como está.
 */
export const toRichText = (value: string) => {
    if (!value || HTML_TAG.test(value)) return value;
    return value
        .split(/\r?\n/)
        .map((line) => `<p>${escapeHtml(line)}</p>`)
        .join('');
};

/** Leaves a space after each block, so reading the text out doesn't run paragraphs together. */
export const separateBlocks = (html: string) =>
    html.replace(/<\/(p|div|li|h[1-6]|blockquote|pre)>|<br\s*\/?>/gi, (tag) => `${tag} `);
